<template>
    <div>
        <label v-if="label" :for="'id-'+uid" v-html="label"></label>
        <input :id="'id-'+uid"
               v-if="mask"
               :ref="'input' + uid"
               v-model="temp_value"
               class="form-control"
               :class="{'is-invalid' : lar_errors.has(name), 'focus': hasValue, 'disabled' : disabled === true }"
                 @blur="blurHandler"
               v-mask="mask"
               :name="name"
               :maxlength="maxlength"
               :disabled="disabled ? disabled : false"
               @focus="$emit('focus')"
               :placeholder="placeholder" />
        <input :id="'id-'+uid"
               v-else
               class="form-control"
               :ref="'input' + uid"
               v-model="temp_value"
               :class="{'is-invalid' : lar_errors.has(name), 'focus': hasValue, 'disabled' : disabled === true }"
               @input="blurHandler"
               :name="name"
               :maxlength="maxlength"
               :disabled="disabled ? disabled : false"
               @focus="$emit('focus')"
               :placeholder="placeholder" />
        <div class="invalid-feedback" v-text="lar_errors.get(name)"></div>
            <!--<span class="invalid-feedback">{{ errors.first(name) }}</span>-->
    </div>
</template>

<script>
    import lar_errors from '../../helpers/Errors'

    export default {
        name: "SsInput",
        props: {
            label: {
                type: String,
                default: ''
            },
            value: {
                type: String,
                default: ''
            },
            name: {
                type: String,
                default: ''
            },
            mask: {
                type: String,
                default: ''
            },
            placeholder: {
                type: String,
                default: ''
            },
              maxlength: {
                type: String,
                default: ''
              },
            'type': {
                type: String,
                default: ''
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        components: lar_errors,
        data() {
            return {
                lar_errors: lar_errors,
                temp_value: '',
                uid: null
            }
        },
        mounted () {
            this.uid = this._uid;
            this.temp_value = this.value;
        },
        computed: {
            hasValue(){
                return this.value && this.value.length > 0;
            }
        },
        methods: {
            blurHandler(){
                this.updateInput();
                this.$emit('blur')
            },
            updateInput() {
                if(lar_errors.has(this.name)){ lar_errors.clear(this.name); }
                this.$emit('input', this.$refs['input' + this.uid].value);
            }
        },
        watch: {
            value(to){
                this.temp_value = to;
                this.$forceUpdate();
            }
        }
    }
</script>

<style scoped>

</style>
